import { styled, Paper, Typography } from '@mui/material';
import SurprisePerkCircle from 'assets/icons/SurprisePerkCircle';

import DesktopArrowLeft from 'assets/icons/DesktopArrowLeft';
import DesktopArrowRight from 'assets/icons/DesktopArrowRight';
import MobileArrowLeft from 'assets/icons/MobileArrowLeft';
import MobileArrowRight from 'assets/icons/MobileArrowRight';

import { palette } from 'assets/styles/colors';
import { theme } from 'assets/themes/zizzi';

const textBG = palette.sunshine[900];
const expireBG = palette.sunshine[500];

interface ExpiryProps {
  expiry: string;
}

export const Wrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 2rem;
  position: relative;
`;

export const StyledBox = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledPaper = styled(Paper)`
  align-items: center;
  border-radius: ${theme.radius?.sm};
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  position: absolute;
  top: 0;
  z-index: 1;
`;

export const VisitText = styled(Typography)`
  font-weight: 900;
  line-height: 2;
  text-align: center;

  @media (max-width: 390px) {
    font-size: 12px;
  }
`;

export const Highlight = styled('span')<ExpiryProps>`
  background: ${textBG};
  border-radius: 4px;
  color: white;
  padding: 3px 5px;

  ${({ expiry }) => expiry === 'true' && `background: ${expireBG}`}
`;

export const SurprisePerkImage = styled(SurprisePerkCircle)`
  height: auto;
  margin-bottom: -3rem;
  max-width: 350px;
  width: 90%;

  @media (min-width: 391px) and (max-width: 600px) {
    margin-bottom: -5rem;
    width: 60%;
  }
`;

export const SmallArrowLeft = styled(MobileArrowLeft)`
  width: 55px;
  height: 125px;

  @media (max-width: 280px) {
    margin-left: -0.5rem;
  }

  ${theme.breakpoints.up('sm')} {
    display: none;
  }
`;

export const SmallArrowRight = styled(MobileArrowRight)`
  height: 130px;
  width: 50px;

  @media (max-width: 280px) {
    margin-right: -0.5rem;
  }

  ${theme.breakpoints.up('sm')} {
    display: none;
  }
`;

export const ArrowLeft = styled(DesktopArrowLeft)`
  ${theme.breakpoints.down('sm')} {
    display: none;
  }
`;

export const ArrowRight = styled(DesktopArrowRight)`
  ${theme.breakpoints.down('sm')} {
    display: none;
  }
`;
